module.exports = __webpack_public_path__ + "static/img/Band_nato_orange.e28cc34.jpg";